<template>
    <div class="hosting-benefits">
        <svg-vue icon="hosting-benefit" class="benefit-image" />
        <div class="benefit-content">
            <h2 class="benefit-title">
                Fusebox Hosting
            </h2>

            <div v-if="'downgrade' === styling" class="benefit-text">
                By turning off Easy Hosting, you’ll lose the following features:
            </div>

            <div class="benefit-lists">
                <ul :class="['benefit-list', styling]">
                    <li class="benefit-list-item">
                        All-in-one dashboard
                    </li>
                    <li class="benefit-list-item">
                        Detailed analytics
                    </li>
                    <li class="benefit-list-item">
                        Drag-and-drop uploads
                    </li>
                </ul>
                <ul :class="['benefit-list', styling]">
                    <li class="benefit-list-item">
                        Pre-episode scheduling
                    </li>
                    <li class="benefit-list-item">
                        Custom episode art
                    </li>
                    <li class="benefit-list-item">
                        Easy host migration
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        styling: {
            type: String,
            default: 'upgrade',
        },
    },
};
</script>
